// This file sets the config for each individual cluster bubble
import variables from 'assets/styles/scss/shared/_variables.module.scss'
import { popupTemplate } from 'components/Reporting/Overview/GraphicalDetails/ContributionsLocation/ClusterMap/SharedConfig'

const symbolConfig = {
  type: 'simple-marker',
  color: variables.white,
  style: 'circle',
  outline: {
    color: variables['iris-900'],
    width: 3,
  },
}

// Location bubble label format
const labelExpression = () => {
  return `
          var value = $feature.contribution_sum
          var num = Count(Text(Round(value)));

          if(value == 0){
            return "no";
          }
          Decode(num,
            4, Text(value / Pow(10, 3), "##.0k"),
            5, Text(value / Pow(10, 3), "##k"),
            6, Text(value / Pow(10, 3), "##k"),
            7, Text(value / Pow(10, 6), "##m"),
            8, Text(value / Pow(10, 6), "##m"),
            9, Text(value / Pow(10, 6), "##m"),
            10, Text(value / Pow(10, 6), "##m"),
            Text(value, "#,###")
          )
        `
}

// Label config for location bubble
export const labelingInfo = [
  {
    labelExpressionInfo: {
      expression: labelExpression(),
    },
    symbol: {
      type: 'text',
      color: variables.black,
    },
    labelPlacement: 'center-center',
  },
]

export const ClusterConfig = (t: any) => {
  return {
    type: 'cluster',
    clusterMinSize: 28,
    clusterMaxSize: 28,
    objectIdField: 'id',
    fields: [
      {
        name: 'contribution_sum',
        onStatisticField: 'contributions',
        statisticType: 'sum',
      },
      {
        name: 'contributor_sum',
        onStatisticField: 'contributors',
        statisticType: 'sum',
      },
      {
        name: 'name',
        type: 'string',
      },
    ],
    popupTemplate: popupTemplate(t),
    symbol: symbolConfig,
    labelingInfo: labelingInfo,
    showLabels: true,
  }
}
